import { createFileRoute } from '@tanstack/react-router';

import { RoutePlaceholder } from '@/components/app/RoutePlaceholder';

export const Route = createFileRoute('/savi/asset/$assetId')({
    component: AssetDetail,
});

function AssetDetail() {
    const { assetId } = Route.useParams();
    return <RoutePlaceholder title={`SAVI — Asset ${assetId}`} />;
}
